export const BASE_MODULES_LIST =
  "BASE_MODULES_LIST";

export const BASE_MODULES_PAGINATION =
    "BASE_MODULES_PAGINATION";
  
export const BASE_MODULE_UPDATE = "BASE_MODULE_UPDATE";

export const BASE_MODULE_INSERT = "BASE_MODULE_INSERT";

export const BASE_MODULE_DELETE = 'BASE_MODULE_DELETE'

export const BASE_MODULES_LOADING =
  "BASE_MODULES_LOADING";

export const BASE_MODULES_ERROR =
    "BASE_MODULES_ERROR";
  
export const SET_BASE_MODULE_TYPES = 'SET_BASE_MODULE_TYPES'
